import { useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useNotification } from "../../contexts/NotificationContext";
import { authFetch } from '../../utils/authFetch';

const ExcluirPlano = () => {
    const { id } = useParams();    
    const { showNotification } = useNotification();
    const navigate = useNavigate();

    const [confirmado, setConfirmado] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!confirmado) {
            showNotification("danger", "É necessário confirmar a exclusão");
            return;
        }

        try {
            const response = await authFetch(`plan/${id}`, {
                method: 'DELETE',                
            });

            if (!response.ok) throw new Error('Erro ao excluir plano');

            showNotification("success", "Plano excluído com sucesso!");
            navigate('/Planos');
        } catch (error) {
            console.error(error);
            showNotification("danger", "Erro ao excluir plano");
        }
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Excluir Plano</h4>
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <form onSubmit={handleSubmit}>
                            <fieldset className="col-md-6">
                                <div className="mb-3">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={confirmado}
                                            onChange={(e) => setConfirmado(e.target.checked)}
                                        />
                                        {' '} Confirmo a exclusão deste plano
                                    </label>
                                </div>
                                <div className="card-footer" style={{ paddingLeft: "0" }}>
                                    <Link to={'/Planos'} className="btn btn-info btn-sm">Voltar</Link>
                                    <button type="submit" className="btn btn-danger btn-sm mx-1">Excluir</button>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExcluirPlano;
